
<script>import Loader from '/app/components/Loader.html'
import { setDeep } from 'svelte-extras'

export default {

	computed: {
		loaded: stories => !!stories,
	},

	oncreate() {
		var feed = new Instafeed({
			get: 'user',
			userId: '_INSTAGRAM_USER_ID', // see: http://www.instaid.co.uk/
			clientId: '_INSTAGRAM_CLIENT_ID',
			accessToken: '_INSTAGRAM_ACCESS_TOKEN',
			resolution: 'standard_resolution',
			limit: 4,
			mock: true,
			success: json => {
				// console.log(json)
				const stories = _.map(json.data, story => {
					return {
						href: story.link,
						src: story.images.standard_resolution.url,
						alt: story.caption.text,
					}
				})
				this.set({
					username: json.data[0].user.username,
					stories,
				})
			},
		})
		feed.run()

		// unfortunately, this is necessary to make sure
		// any page setup elsewhere is recalibrated
		this.observe('loaded', () => {
			setTimeout(() => {
				var resizeEvent = window.document.createEvent('UIEvents')
				resizeEvent.initUIEvent('resize', true, false, window, 0)
				window.dispatchEvent(resizeEvent)
			}, 0)
		})
	},

	components: {
		Loader,
	},

	methods: {
		setDeep,
		setStoryState(index) {
			// let the DOM render
			setTimeout(() => this.setDeep(`stories[${index}].loaded`, true), 0)
		},
	},

}

</script>{{#if loaded}}
<h2><a href="https://www.instagram.com/{{username}}/">@{{username}}</a></h2>
<div class="items">{{#each stories as story, index}}<a class="item {{story.loaded ? 'loaded' : ''}}" href="{{story.href}}" target="_blank">
    <div class="bg" style="background-image:url({{story.src}});"><img src="{{story.src}}" alt="{{story.alt}}" on:load="setStoryState(index)"></div></a>{{/each}}
</div>{{else}}
<Loader></Loader>{{/if}}